import { useEffect, useRef } from 'react'

/**
 * Track if component has been unmounted. Returns a function to check the current state.
 */
export const useMounted = () => {
	const ref = useRef(false)

	useEffect(() => {
		ref.current = true
		return () => {
			ref.current = false
		}
	}, [])

	return () => ref.current
}
